export default __webpack_public_path__ + "static/media/img_failed.abbff36a.webp";